<template>
  <div class="login-container">
    <div class="login-form-box" v-if="isLoginShow">
      <div class="login-top">
        <svg-icon icon-class="xrk-logo-w" class="login-logo"/>
        <div class="top-right">
          <span>客服电话：0371-89912266</span>
          <span>简体中文</span>
        </div>
      </div>
      <div class="login-main">
        <div class="tip-box" :class="{'width':index==2}">
          <img src="../../assets/image/login/quotation-before.png" />
          <div class="tip-text" v-if="index==0">
            <p>智能报表</p>
            <p>营销业绩分析汇总</p>
          </div>
          <div class="tip-text" v-if="index==1">
            <p>客户报备</p>
            <p>报备单据流程可溯</p>
          </div>
          <div class="tip-text" v-if="index==2">
            <p>客户成交</p>
            <p>电子档案留存</p>
          </div>
          <img src="../../assets/image/login/quotation-after.png" />
        </div>
        <div class="from">
          <login-from :redirect="redirect" class="login-form" @switch-status="isLoginShow=false" />
        </div>
      </div>
      <div class="swiper">
        <el-carousel :interval="9000" height="100%" arrow="never" @change="change">
          <el-carousel-item v-for="(item,index) in loginImgs" :key="index">
            <img :src="item" alt />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="password-form-box" v-else>
      <password-from @switch-status="isLoginShow=true"></password-from>
    </div>
    <div class="login-bottom">
      <div class="bottom-main">
        <img src="../../assets/image/login/national-emblem.png" class="national-emblem" />
        Copyright © 2020 zhileCloudStore.cn All Rights Reserved | 豫ICP备17018001号
        <img
          src="../../assets/image/login/login-credible.png"
          class="login-credible"
        />
      </div>
    </div>
  </div>
</template>

<script>
import loginFrom from "./loginFrom";
import passwordFrom from "./passwordFrom";

import loginImg1 from "../../assets/image/login/login-img1.png";
import loginImg2 from "../../assets/image/login/login-img2.png";
import loginImg3 from "../../assets/image/login/login-img3.png";
export default {
  name: "Login",
  components: { loginFrom,passwordFrom },
  data() {
    return {
      loginImgs: [loginImg1, loginImg2, loginImg3],
      isLoginShow: true,
      redirect: undefined,
      index: 0
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        // //console.log("改变的路径", route);
        // // this.redirect = route.query && route.query.redirect;
        // if (route.query.redirect=='/login/forgetPassword') {
        //   // this.isLoginShow=false;
        // }
      },
      immediate: true
    }
  },
  created() {
    // window.addEventListener('hashchange', this.afterQRScan)
  },
  destroyed() {
    // window.removeEventListener('hashchange', this.afterQRScan)
  },
  mounted() {
    //console.log(this.$store);
  },
  methods: {
    afterQRScan() {
      // const hash = window.location.hash.slice(1)
      // const hashObj = getQueryObject(hash)
      // const originUrl = window.location.origin
      // history.replaceState({}, '', originUrl)
      // const codeMap = {
      //   wechat: 'code',
      //   tencent: 'code'
      // }
      // const codeName = hashObj[codeMap[this.auth_type]]
      // if (!codeName) {
      //   alert('第三方登录失败')
      // } else {
      //   this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
      //     this.$router.push({ path: '/' })
      //   })
      // }
    },
    change(i) {
      this.index = i;
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  min-width: 1200px;
  min-height: 600px;
  overflow: hidden;

  .login-form-box {
    width: 100%;
    height: 86%;

    .login-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      top: 29px;
      box-sizing: border-box;
      padding: 0 50px 0 38px;
      width: 100%;
      height: 57px;
      z-index: 99;

      .login-logo {
        width: 100px;
        height: 57px;
      }

      .top-right {
        display: flex;
        align-items: center;
        justify-content: space-between;

        font-size: 14px;
        font-weight: 400;
        color: #fff;

        span:first-child {
          margin-right: 28px;
        }
      }
    }

    .login-main {
      display: flex;
      justify-content: space-between;
      align-items: center;

      height: calc(86% - 132px);
      width: 1000px;
      position: absolute;
      z-index: 99;
      left: 50%;
      top: 66px;
      transform: translateX(-50%);

      .from {
        background: #fff;
        box-shadow: 0px 2px 27px 0px rgba(5, 17, 28, 0.23);
      }

      .tip-box {
        position: relative;

        height: 133px;
        display: flex;
        justify-content: space-between;

        font-weight: 400;
        text-align: left;
        color: #fff;

        .tip-text {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          p {
            margin: 0;
          }
        }

        img {
          width: 39px;
          height: 31px;

          &:first-child {
            margin-right: 18px;
            position: relative;
            bottom: 5px;
          }

          &:last-child {
            margin-left: 18px;
            margin-top: 83px;
          }
        }
      }

      @media (max-width: 1920px) {
        .from {
          width: 364px;
          height: 392px;
        }

        .tip-box {
          top: 175px;
          font-size: 40px;
        }
      }

      @media (min-width: 1920px) {
        .from {
          width: 406px;
          height: 436px;
        }

        .tip-box {
          top: 191px;
          font-size: 44px;
        }
      }
    }

    .swiper {
      width: 100%;
      height: 100%;

      .el-carousel {
        height: 100%;

        img {
          width: 100%;
          height: 100%;
        }

        // .login-main {
        //   width: 1000px;
        //   position: absolute;
        //   z-index: 99;
        //   left: 50%;
        //   top: 50%;
        //   transform: translate(-50%, -50%);

        //   .from {
        //     float: right;
        //     width: 406px;
        //     height: 436px;
        //     max-width: 406px;
        //     max-height: 436px;
        //     background: #fff;
        //     box-shadow: 0px 2px 27px 0px rgba(5, 17, 28, 0.23);
        //   }

        //   .tip-box {
        //     // position: absolute;
        //     // left: 18%;
        //     // bottom: 12.5%;
        //     float: left;

        //     width: 380px;
        //     height: 133px;
        //     display: flex;
        //     justify-content: space-between;

        //     font-size: 44px;
        //     font-weight: 400;
        //     text-align: left;
        //     color: #fff;

        //     .tip-text {
        //       height: 100%;
        //       display: flex;
        //       flex-direction: column;
        //       justify-content: space-between;

        //       p {
        //         margin: 0;
        //       }
        //     }

        //     img {
        //       width: 39px;
        //       height: 31px;

        //       &:first-child {
        //         position: relative;
        //         bottom: 5px;
        //       }

        //       &:last-child {
        //         margin-top: 83px;
        //       }
        //     }
        //   }
        //   .width {
        //     width: 510px;
        //   }
        // }
      }
    }
  }

  .password-form-box {
    width: 100%;
    height: 86%;
    .password-top {
      display: flex;
      align-items: center;

      width: 100%;
      height: 60px;
      background: #212b4b;

      img {
        margin-left: 40px;
        width: 158px;
        height: 32px;
      }
    }

    .password-main {
      position: relative;
      padding: 40px 212px 0;
      box-sizing: border-box;
      width: 100%;
      height: calc(100% - 60px);
      background-color: #f0f0f5;

      .bg-left {
        position: absolute;
        left: 0;
        top: 87px;

        width: 338px;
        height: 348px;
      }

      .bg-right {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 330px;
        height: 346px;
      }

      .password-box {
        position: relative;
        width: 100%;
        height: 100%;
        min-height: 520px;
        background: #fff;
        box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.3);
        z-index: 9;

        .password-title {
          display: flex;
          justify-content: center;
          align-items: center;

          border-bottom: 1px solid #e5e5ea;
          height: 18.4%;
          font-size: 32px;
          font-weight: 400;
          color: #000;
        }
      }
    }
  }

  .login-bottom {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 14%;

    font-size: 12px;
    font-weight: 400;
    color: #667790;
    background-color: #f0f0f5;

    .bottom-main {
      display: flex;
      align-items: center;
      height: 30px;
      .national-emblem {
        margin-right: 7px;
        width: 18px;
        height: 20px;
      }

      .login-credible {
        margin-left: 20px;
        width: 86px;
        height: 100%;
      }
    }
  }
}
</style>
